import CreateInvestmentError from './CreateInvestmentError';
class NotEnoughFunds extends CreateInvestmentError {
    constructor(options) {
        super('The investor has not enough funds', options);
    }
}
export default NotEnoughFunds;
